import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { Dashboard } from './components/Dashboard';
import { ParentDashboard } from './components/ParentDashboard';
import { CourseView } from './components/CourseView';
import { LessonList } from './components/LessonList';
import { Lesson } from './components/Lesson';
import { Flashcards } from './components/Flashcards';
import { Quiz } from './components/Quiz';
import { TestMode } from './components/TestMode';
import { MindMap } from './components/MindMap';
import { Profile } from './components/Profile';
import { EUMap } from './components/EUMap';
import { AdminDashboard } from './components/AdminDashboard';
import { WrittenQuiz } from './components/WrittenQuiz';
import { Lernstand } from './components/Lernstand';
import { FeedbackHistory } from './components/FeedbackHistory';
import { Messages } from './components/Messages';
import { MessagePopup } from './components/MessagePopup';
// New components for text-based courses
import { TextLessonView } from './components/TextLessonView';
import { FillInQuiz } from './components/FillInQuiz';
import { TransformQuiz } from './components/TransformQuiz';
import { VocabMatch } from './components/VocabMatch';
import { VocabQuiz } from './components/VocabQuiz';
import { MathExercise } from './components/MathExercise';
import { AskClaude } from './components/AskClaude';
import { SongList } from './components/SongList';
import { SongLearn } from './components/SongLearn';

function App() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Laden...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  // Parent view
  if (user?.role === 'parent') {
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<ParentDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    );
  }

  // Student view
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/course/:courseId" element={<CourseView />} />
        <Route path="/course/:courseId/lessons" element={<LessonList />} />
        <Route path="/course/:courseId/lessons/:lessonId" element={<Lesson />} />
        <Route path="/course/:courseId/flashcards" element={<Flashcards />} />
        <Route path="/course/:courseId/quiz" element={<Quiz />} />
        <Route path="/course/:courseId/test" element={<TestMode />} />
        <Route path="/course/:courseId/mindmaps" element={<MindMap />} />
        <Route path="/course/:courseId/written" element={<WrittenQuiz />} />
        {/* Text-based course routes */}
        <Route path="/course/:courseId/text-lessons" element={<TextLessonView />} />
        <Route path="/course/:courseId/fill-in" element={<FillInQuiz />} />
        <Route path="/course/:courseId/transform" element={<TransformQuiz />} />
        <Route path="/course/:courseId/vocab-match" element={<VocabMatch />} />
        <Route path="/course/:courseId/vocab-quiz" element={<VocabQuiz />} />
        <Route path="/course/:courseId/math-exercise" element={<MathExercise />} />
        <Route path="/course/:courseId/ask-claude" element={<AskClaude />} />
        <Route path="/course/:courseId/songs" element={<SongList />} />
        <Route path="/course/:courseId/songs/:songId" element={<SongLearn />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/map" element={<EUMap />} />
        <Route path="/lernstand" element={<Lernstand />} />
        <Route path="/lernstand/:courseId" element={<Lernstand />} />
        <Route path="/feedback" element={<FeedbackHistory />} />
        <Route path="/feedback/:courseId" element={<FeedbackHistory />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <MessagePopup />
    </Layout>
  );
}

export default App;
